import { Box, styled, Tab, Tabs } from '@mui/material';

const Container = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  width: '100%',
}));

const TabPanel = styled(Box)(({ theme }) => ({
  width: '100%',
  paddingTop: theme.spacing(1),
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  minHeight: '36px',
  '& .MuiTab-root': {
    minHeight: '36px',
    padding: theme.spacing(0.5, 1),
    fontSize: '0.75rem',
    textTransform: 'none',
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  fontSize: '0.75rem',
  fontWeight: 500,
  padding: theme.spacing(0.5, 1),
  minHeight: '36px',
}));

export { Container, TabPanel, StyledTabs, StyledTab };
